/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Load_FailedInputs */

const en_us2_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This part could not load. Check your connection.`)
};

const pt_br2_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar esta parte. Confira sua conexão.`)
};

const es_419_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar esta parte. Revisa tu conexión.`)
};

const pt_pt2_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar esta parte. Verifica a tua ligação.`)
};

const fr_fr2_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette partie n'a pas pu se charger. Vérifie ta connexion.`)
};

const de_de2_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Teil konnte nicht geladen werden. Prüf deine Verbindung.`)
};

const it_it2_profile_load_failed = /** @type {(inputs: Profile_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa parte non si è caricata. Controlla la connessione.`)
};

/**
* | output |
* | --- |
* | "This part could not load. Check your connection." |
*
* @param {Profile_Load_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_load_failed = /** @type {((inputs?: Profile_Load_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Load_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_load_failed(inputs)
	if (locale === "es-419") return es_419_profile_load_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_load_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_load_failed(inputs)
	if (locale === "de-DE") return de_de2_profile_load_failed(inputs)
	if (locale === "it-IT") return it_it2_profile_load_failed(inputs)
	return en_us2_profile_load_failed(inputs)
});
export { profile_load_failed as "profile.load_failed" }